export const ENTRY_SLIDE_TIME = 300;
export const SHOW_MORE_SLIDE_TIME = 300;
export const CONTENT_TRANSITION_TIME = 200;
export const NOTIFICATION_TRANSITION_TIME = 200;
